import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../components/AuthContext";
import { toast } from "react-toastify";
import "../styles/Auth.css";

export default function ResetPasswordPage() {
const { emailForOtp, resetPassword } = useAuth();
const [otp, setOtp] = useState("");
const [newPassword, setNewPassword] = useState("");
const [loading, setLoading] = useState(false);

const navigate = useNavigate();

const handleSubmit = async (e) => {
e.preventDefault();


if (!emailForOtp) {
  toast.error("Please start the reset process again.");
  return navigate("/forgot-password");
}

if (otp.length < 6) {
  toast.warning("Enter valid 6-digit OTP");
  return;
}

if (newPassword.length < 6) {
  toast.warning("Password must be at least 6 characters");
  return;
}

setLoading(true);

try {
  const res = await resetPassword(emailForOtp, otp, newPassword);

  if (res.success) {
    toast.success("Password reset successful");
    navigate("/login");
  } else {
    toast.error(res.message || "Reset failed");
  }
} catch (err) {
  console.error(err);
  toast.error("Something went wrong");
} finally {
  setLoading(false);
}


};

return ( <div className="auth-page"> <div className="auth-card"> <h2>Reset Password</h2> <p>
Enter the OTP sent to <strong>{emailForOtp}</strong> </p>


    <form onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Enter OTP"
        value={otp}
        maxLength={6}
        onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
        required
      />

      <input
        type="password"
        placeholder="New Password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        required
      />

      <button type="submit" disabled={loading}>
        {loading ? "Resetting..." : "Reset Password"}
      </button>
    </form>
  </div>
</div>


);
}
